export enum UserRole {
    MceViewer = "mpi.mce.viewer",
    MceOperator = "mpi.mce.operator",
    MceApiAccess = "mpi.mce.api.access",
    MceDeveloper = "mpi.mce.developer",
}
